import { render } from "./BuyBooks.vue?vue&type=template&id=3fd6b480"
import script from "./BuyBooks.vue?vue&type=script&lang=js"
export * from "./BuyBooks.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/Buyback/BuyBooks.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3fd6b480"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3fd6b480', __exports__)) {
    api.reload('3fd6b480', __exports__)
  }
  
  module.hot.accept("./BuyBooks.vue?vue&type=template&id=3fd6b480", () => {
    api.rerender('3fd6b480', render)
  })

}


export default __exports__